var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#1BFCBE","key":0}),React.createElement("path",{"d":"M6.85724 12.3428L10.2858 15.7714L17.143 8.91425","stroke":"#04022E","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Checkmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
